module.exports = __webpack_public_path__ + "static/media/albert-einstein.c7537ab5.webp";